import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**@description This weird looking type allows for strong typing when inputting parameters for this component from our service helper methods! */
export type IModalConfirmOptions = {
  [P in keyof ModalContentConfirmComponent as ModalContentConfirmComponent[P] extends string | boolean | string[] | undefined
    ? P
    : never]?: ModalContentConfirmComponent[P];
};

@Component({
  selector: 'app-modal-content-confirm',
  templateUrl: './modal-content-confirm.component.html',
  standalone: false,
})
export class ModalContentConfirmComponent implements OnInit {
  @Input() public questionText = '';
  @Input() public title = '';
  @Input() public isDisabled = false;
  @Input() public yesText?: string;
  @Input() public noText?: string;

  @Output() public readonly closed = new EventEmitter<boolean>();

  public ngOnInit(): void {
    if (!this.yesText) this.yesText = 'Yes';
    if (!this.noText) this.noText = 'No';
  }

  public close(hasValue: boolean): void {
    this.closed.emit(hasValue);
  }
}
